import { Helmet } from 'react-helmet-async';

const ProductsPageHelmet = () => {
  return (
    <Helmet>
      <title>About Us</title>
      <meta
        name='description'
        content='Explore Interlink Oceana’s reliable shipment services, including freight forwarding, cargo handling, and global logistics solutions designed to streamline your business.'
      />
      <meta property='og:type' content='website' />
      <meta
        property='og:url'
        content='https://www.interlinkoceana.com/services'
      />
      <meta
        property='og:title'
        content='Interlink Oceana | Comprehensive Shipment Solutions'
      />
      <meta
        property='og:image'
        content='https://www.interlinkoceana.com/assets/img/shipment-services.png'
      />
      <meta
        property='og:description'
        content='Discover Interlink Oceana’s professional shipment solutions. From freight forwarding to cargo handling, we provide the tools to support your global business.'
      />
      <meta property='og:site_name' content='Interlink Oceana' />
      <meta property='og:locale' content='en_US' />
    </Helmet>
  );
};

export default ProductsPageHelmet;
